import { Result, Typography } from "antd";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@sol/uikit/general/Button";

const { Paragraph, Text } = Typography;

type Props = {
    status: "success" | "error" | "info" | "warning";
    title: string;
    message: string;
    timeout?: number;
    to: string;
    onTimeout?: () => void;
    className?: string;
};

export function RedirectResult({ title, message, timeout = 5, to, onTimeout, className, status }: Props) {
    const [timeLeft, setTimeLeft] = useState(timeout);
    const router = useRouter();
    const [t] = useTranslation();

    let handler: ReturnType<typeof setTimeout>;

    const doRedirect = () => {
        if (onTimeout) {
            onTimeout();
        }
        router.replace(to);
    };

    useEffect(() => {
        clearTimeout(handler);
        if (timeLeft > 0) {
            handler = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
        } else {
            doRedirect();
        }

        return () => clearTimeout(handler);
    }, [timeLeft]);

    return (
        <Result
            rootClassName={className}
            status={status}
            title={title}
            subTitle={
                <Paragraph>
                    {message}
                    <br />
                    <Text type="secondary">{t("notification.fullscreenRedirect.message", { timeLeft })}</Text>
                </Paragraph>
            }
            extra={[
                <Button key="redirect" onClick={doRedirect}>
                    {t("notification.fullscreenRedirect.skip")}
                </Button>,
            ]}
        />
    );
}
